import React from 'react'
import map from 'lodash/map'
import type { FlatBlogCategory } from './blogCategoryTree.utils'
import { Select } from '@ztechapps/webui.input'
import { buildBlogCategoryPathLabel } from './blogCategoryTree.utils'

/** A tree-style picker: the menu lists every blog category indented by depth, the chosen value shows its full path. */
export type BlogCategorySelectProps = { flat: FlatBlogCategory[] } & Record<string, any>

export const BlogCategorySelect = ({ flat, ...rest }: BlogCategorySelectProps) => {
  const options = map(flat, (category) => ({
    value: category._id,
    label: buildBlogCategoryPathLabel(flat, category._id),
    name: category.name,
    depth: category._depth,
  }))

  return (
    <Select
      {...{
        placeholder: 'Choose a category',
        isClearable: false,
        ...rest,
        options,
        formatOptionLabel: (option, { context }) =>
          context === 'menu' ? (
            <span style={{ paddingLeft: `${(option.depth - 1) * 1}rem` }}>{option.name}</span>
          ) : (
            option.label
          ),
      }}
    />
  )
}
